<template>
  <b-container>
    <WizardPageTitle title="API options" />
    <b-row>
      <b-col>
        <b-form>
          <b-form-group description="Generate OpenAPI (Swagger) specification for your API">
            <b-form-checkbox v-model="openapi">
              Enable OpenAPI
            </b-form-checkbox>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <WizardPrevNext />
  </b-container>
</template>

<script>
import WizardPageTitle from './widgets/WizardPageTitle.vue';
import WizardPrevNext from './widgets/WizardPrevNext.vue';
import navigationMixin from './mixins/navigation';

export default {
  name: 'Api',
  components: {
    WizardPageTitle,
    WizardPrevNext,
  },
  mixins: [navigationMixin],
  data() {
    return {
      openapi: !!this.$store.state.recipe.openapi,
    };
  },
  methods: {
    commit() {
      this.$store.commit('updateRecipe', {
        openapi: this.openapi,
      });
      return true;
    },
  },
};
</script>
